import { render, staticRenderFns } from "./SubmitTemplate.vue?vue&type=template&id=16530eec&scoped=true"
import script from "./SubmitTemplate.vue?vue&type=script&lang=js"
export * from "./SubmitTemplate.vue?vue&type=script&lang=js"
import style0 from "./SubmitTemplate.vue?vue&type=style&index=0&id=16530eec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16530eec",
  null
  
)

export default component.exports